/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // MAIN NAVIGATION
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'dropdown',
            closeOnOutsideClick: true
        });
    }

    // SIDE NAVIGATION
    const sideNav = document.querySelector('nav.sidenav');
    if( sideNav ){
        responsiveNav(sideNav, {
            navType: 'dropdown',
            closeOnOutsideClick: false,
            showTabsOnFocus: false,
            menuButtonSelector: '.sidenav__menu-btn',
            dropdownSelector: '.sidenav__menu',
            addWrapperClass: false,
            setInert: false
        });
    }

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    //POPUP Video
    $('.js-video-popup').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
        closeMarkup : '<button title="%title%" type="button" class="popup__close mfp-close"><span>Close</span> <div class="close-x"></div></button>'
	});

    //SEARCH POPUP
    $('.js-open-search').magnificPopup({
		type:'inline',
		alignTop: true,
		modal: true,
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		mainClass: 'mfp-fade',
		focus : '#p-search',
		callbacks: {
			// When elemened is focused, some mobile browsers in some cases zoom in
		    // It looks not nice, so we disable it:
            beforeOpen: function() {
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#p-search';
                }
            }
		}
    });
    $(document).on('click', '.js-close-search', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
	/* END SEARCH CONTROLS */

    /* ALERTS DISMISSED */
    if ($('.alert-bar')) {
        var alertbar = $('.alert-bar');
        var closealertbar = $('.close-alertbar');

        $(closealertbar).on('click', function (e) {
            e.preventDefault();
            //close the alertbar
            alertbar.slideUp('fast');
            // persist the dismissal in a cookie
            document.cookie = closealertbar.data('alert-cookie');
        });

    }

})(jQuery)
